module.exports = __webpack_public_path__ + "static/media/banner1.358a6921.jpg";